// src/components/dashboard/ai_flow/OptimizationControls.jsx
import React from "react";

function OptimizationControls({ selectedJob, onOptimize, isLoading, error }) {
  // Don't render anything if no job is selected
  if (!selectedJob) {
    return null;
  }

  // Use the correct property names from the context object
  const jobTitle = selectedJob.jobTitle || "N/A";
  const companyName = selectedJob.companyName || "N/A";
  const location = selectedJob.location || "Location not specified";

  return (
    <div className="widget-card">
      <h3 className="text-lg font-semibold text-gray-700 mb-3">
        Ready to Optimize
      </h3>

      {/* Job Details Section */}
      <div className="mb-4">
        <p className="text-base font-medium text-gray-900 mb-1">{jobTitle}</p>
        <p className="text-sm text-gray-600">{companyName}</p>
        <p className="text-sm text-gray-500">{location}</p>
      </div>

      {/* A clean dividing line */}
      <hr className="controls-divider" />

      {/* Action Button Section */}
      <div className="flex flex-col items-center">
        <button
          onClick={onOptimize}
          disabled={isLoading}
          className="opt-page-btn opt-page-btn-primary w-full max-w-xs" // Primary button style
        >
          {isLoading
            ? "Optimizing, please wait..."
            : "Optimize Resume for this Job"}
        </button>
        {error && <p className="error-message mt-3">{error}</p>}
      </div>
    </div>
  );
}

export default OptimizationControls;
